import { render, staticRenderFns } from "./paymentDetail.vue?vue&type=template&id=57852f2a&scoped=true"
import script from "./paymentDetail.vue?vue&type=script&lang=js"
export * from "./paymentDetail.vue?vue&type=script&lang=js"
import style0 from "./paymentDetail.vue?vue&type=style&index=0&id=57852f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57852f2a",
  null
  
)

export default component.exports